"use client";

import { useEffect, useRef } from "react";
import * as amplitude from "@amplitude/analytics-browser";
import { amplitudeTrackEvent } from "@/services/Amplitude";

/** Prod host for MyPassportHub app home (PASGF-2187). */
export const VISIT_HOME_HOSTNAME = "app.mypassporthub.com";

/** Amplitude user property `product` for this site. */
export const VISIT_HOME_PRODUCT = "mypassporthub";

/** True for prod and env subdomains (qa04.app.mypassporthub.com, etc.). */
export function isVisitHomeHostname(hostname: string): boolean {
  const host = hostname.toLowerCase();
  return host === VISIT_HOME_HOSTNAME || host.endsWith(`.${VISIT_HOME_HOSTNAME}`);
}

/**
 * Fires `visit_home` once on home (`/` or `/home`) for app.mypassporthub.com hosts.
 * Event props: `domain` (hostname), `landing_domain` (origin + path, no query).
 * Also sets $identify `product` + `domain` for this site.
 */
export function VisitHomeTracker() {
  const hasTracked = useRef(false);

  useEffect(() => {
    if (hasTracked.current) return;

    const hostname = window.location.hostname.toLowerCase();
    if (!isVisitHomeHostname(hostname)) return;

    hasTracked.current = true;

    const domain = window.location.hostname;
    const landing_domain = `${window.location.origin}${window.location.pathname}`;

    const identify = new amplitude.Identify();
    identify.set("product", VISIT_HOME_PRODUCT);
    identify.set("domain", domain);
    amplitude.identify(identify);

    amplitudeTrackEvent("visit_home", {
      domain,
      landing_domain,
    });
  }, []);

  return null;
}

export default VisitHomeTracker;
